import React, { useState, useRef, useMemo, useEffect } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'
import { useSurveyParams } from '../context/SurveyParamsContext'
import { useProgressSaving } from '../hooks/useProgressSaving'
import {
  convertVisibleIf,
  convertTriggers,
  convertQuestionMappings,
  q,
  v,
} from '../utils/convertVisibleIf'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
}) => {
  const { userId, sfdSamplerId, sfdPId } = useSurveyParams()
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  const userIdRef = useRef(null)
  useEffect(() => {
    if (userId) userIdRef.current = userId
  }, [userId])
  // 需要登入嗎
  const requiresLogin = {
    login: userId ? true : false,
    title: '員工編號（邁達特：MA、啟迪：GI、聚上雲：EP、逐鹿：GU）',
    placeholder: 'MA00000',
    alert: '員工編號有誤，請重新登入，謝謝',
    // useUserIdLogin: true,
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  const canShowPrevButtonPages = null
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})
  const bringOptionsMapRef = useRef({})
  // 防止閃閃
  useEffect(() => {
    const timeout = setTimeout(() => {
      const isMobile = window.innerWidth <= 576
      if (!isMobile) return

      const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            const rootEl = document.querySelector('.sd-root-modern')
            if (
              rootEl &&
              !rootEl.classList.contains('sd-root-modern--mobile')
            ) {
              rootEl.classList.add('sd-root-modern--mobile')
              console.log('✅ 強制加上 mobile class 避免抖動')
            }
          }
        }
      })

      observer.observe(document.getElementById('root'), {
        childList: true,
        subtree: true,
      })

      // 清除
      return () => observer.disconnect()
    }, 100) // 100ms 後再判斷

    return () => clearTimeout(timeout)
  }, [])
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(30)
  // }, [])
  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>${window.location.origin}</a>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }

  const visibleIfConditionsInit = convertVisibleIf({
    // 用1開始計算填這裡，工具自動轉成0開始
    // P260407164822624?sfd_p_id=1140941&sfd_sampler_id=101001801
  })
  // const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 0 計算)
  // const notRequired = [117.5]
  const notRequired = null

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  const triggersConditionsInit = convertTriggers([
    // {
    //   type: 'complete',
    //   expression: `({q7} = 1) or ({q11} anyof [1, 2, 3, 4, 5, 6, 7, 8, 9, "other"])`,
    // },
  ])
  // const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null
  // 帶出: 帶入 (用1開始計算填這裡)
  const questionMappings = convertQuestionMappings({
    // q37: 'q38',
  })

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
    questionMappings,
    bringOptionsMapRef,
    userIdRef,
    choiceIndexMapRef,
    sfdSamplerId,
    sfdPId,
  })

  // const newSurvey = new Model(convertedSurvey)

  const surveyModel = useMemo(() => {
    if (!convertedSurvey) return null
    return new Model(convertedSurvey)
  }, [convertedSurvey])

  useProgressSaving({
    userIdRef,
    surveyModel,
    convertedSurvey: myAgreeJson,
    requiresLogin,
    setIsLoading,
    pid,
    ac,
    tk,
    choiceIndexMapRef,
    choicesOrderRef,
    bringOptionsMapRef,
    sfdSamplerId,
  })

  // 當 surveyModel 建立時，自動捲動到頂端
  useEffect(() => {
    if (surveyModel) {
      // 延遲執行以確保 DOM 已更新
      setTimeout(() => {
        // 捲動到頁面頂端
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant', // 平滑捲動，也可以使用 'instant' 立即跳到頂端
        })

        // 或者也可以嘗試捲動問卷容器本身
        const surveyContainer = document.querySelector('.sd-root-modern')
        if (surveyContainer) {
          surveyContainer.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }, 100) // 給 DOM 一點時間完成渲染
    }
  }, [surveyModel])

  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])

  const endMessage = `目前與您相同特性的樣本額滿，已停止收卷，可惜沒辦法繼續參與本次活動。如果覺得這個主題很有意思，非常歡迎您分享本問卷連結給親友，或是加入我們的<a href='https://lin.ee/HWETcqy'>LINE@</a>，隨時得到最新填問卷獲好禮的消息。<p>請按「完成」前往下載 EZChoice 或填寫更多問卷</p>`

  function helpFunction(survey, options) {
    // console.log('survey.getValue(q7)', survey.getValue('q7'))
    // 參考 P231113152849 或 P231101165555 或 P231206105643(政大帶入選項)
  }

  const endSurveyMsg = (survey) => {
    // if (survey.getValue(q(7)) === v(1) || survey.getValue(q(11))?.length > 0) {
    //   setCompletionMessage(endMessage)
    // } else {
    setCompletionMessage(`<div>感謝您的耐心觀看，完成本次IRB課程</div>`)
    // }
  }

  // useEffect(() => {
  //   console.log('bringOptionsMapRef', bringOptionsMapRef)
  // }, [bringOptionsMapRef])

  useSubmitAnswers({
    survey: surveyModel,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    endSurveyMsg,
    bringOptionsMapRef,
    requiresLogin,
    userIdRef,
    enableProgressSaving: requiresLogin.login || !!sfdSamplerId,
    sfdSamplerId,
  })

  return (
    <>
      {surveyModel ? (
        <Survey model={surveyModel} key={pid} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
